import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { environment } from "src/environments/environment";

const endpoint = "File";
export const FileService = {
	endpoint,
	download: async (lookupId: Guid) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Download/${lookupId}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	proxyImage: async (url: string) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/ProxyImage?url=${encodeURIComponent(url)}`, {method: "GET"}),
	upload: async (data: FormData) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/Upload`, {body: data, method: "POST"}),
	uploadBase64: async (base64: string) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/UploadBase64`, {body: base64, headers: {"Content-Type": "plain/text"}, method: "POST"}),
	view: async (lookupId: Guid) => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/View/${lookupId}`, {headers: {"Content-Type": "application/json"}, method: "GET"})
}